import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=50c27260&"
import script from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=js&"
export * from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports